import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { Image, CTA } from '../../';

import styles from './index.module.scss';

const ImageCardTextOver = ({ data, headingLevel = 3 }) => {
	if (!data) return null;

	const CustomHeading = `h${headingLevel}`;

	return (
		<div className={styles.imageCardText}>
			{data.image?.[0] && (
				<Image
					data={data.image[0]}
					className={styles.imageCardText_Image}
				/>
			)}
			{data.heading && <CustomHeading className={styles.imageCardText_Heading}>{data.heading}</CustomHeading>}
			{data.ctas?.[0] && (
				<List
					bullets='none'
					layout='fluid'
					className={styles.imageCardText_Links}
				>
					{data.ctas.map((cta, index) => (
						<li key={index}>
							<CTA
								data={cta}
								className={styles.imageCardText_Btn}
							/>
						</li>
					))}
				</List>
			)}
		</div>
	);
};

ImageCardTextOver.propTypes = {
	data: PropTypes.object,
	headingLevel: PropTypes.number,
};

export default ImageCardTextOver;
